import React, { HTMLAttributes, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Tooltip } from "antd";
import { TooltipPropsWithTitle } from "antd/es/tooltip";
import { omitObj } from "@/utils/method";

export interface OverflowTipProps extends Omit<HTMLAttributes<HTMLDivElement>, "title">, Partial<TooltipPropsWithTitle> {
  attr?: any;
  value?: string;
  textColor?: string;
}
//const { useTranslation } = Hooks;
const OverflowTip: React.FC<OverflowTipProps> = ({ className, value = "", textColor = "", ...rest }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  const [showTip, setShowTip] = useState(false);

  /** useMemo */
  const getContent = useMemo(() => {
    if (value) {
      /* eslint-disable */
      let str = String(value);
      /* eslint-disable */
      let reg = /\r|\n|\r\n/g;
      /* eslint-disable */
      let bool = reg.test(str);
      if (bool) {
        /* eslint-disable */
        let str1 = str.substring(0, str.indexOf("\n")) + "...";
        return str1;
      } else {
        return str;
      }
    } else {
      return value;
    }
  }, [value]);

  /** method */
  const showChange = (e: any) => {
    const width = e.target.offsetWidth;
    const scrollWidth = e.target.scrollWidth;
    setShowTip(width < scrollWidth);
  };
  return (
    <div className={cx(styles["tip-box"], className)}>
      {showTip ? (
        <Tooltip
          placement="topLeft"
          overlayClassName={cx(styles["tp"], "tp-g")}
          defaultOpen={true}
          title={
            <div
              className="tip-content"
              dangerouslySetInnerHTML={{
                __html: String(value)
                  .replace(/\r|\n|\r\n/g, "<br>")
                  .replace(/\t/g, "&nbsp;&nbsp;"),
              }}
            ></div>
          }
          {...omitObj(rest, ["title"])}
        >
          <div className="value-box" style={{ color: textColor }} onMouseEnter={showChange}>
            {getContent}
          </div>
        </Tooltip>
      ) : (
        <div className="value-box" style={{ color: textColor }} onMouseEnter={showChange}>
          {getContent}
        </div>
      )}
    </div>
  );
};
export default observer(OverflowTip);
